import styled, { css } from 'styled-components';
import { status } from '../theme/color';
const circleShapeMixin = css `
  @apply rounded-full w-4 h-4 justify-center;
`;
const squareShapeMixin = css `
  @apply rounded px-2 py-1;
`;
export const Item = styled.p `
  color: ${(props) => (props.status ? 'var(--text-color-0)' : 'var(--text-color-2)')};
  background-color: ${(props) => (props.status ? status[props.status] : 'transparent')};
  ${(props) => (props.shape === 'circle' ? circleShapeMixin : squareShapeMixin)}

  @apply text-xs cursor-pointer flex m-0 items-center;
`;
